import React from 'react';
import { connect } from '../../redux/store';
import { Link } from '@reach/router';
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import { CardCol, CardRow, C } from '@kineticdata/bundle-common';
import { RequestMetaWrapper } from './RequestMetaWrapper';
import * as helpers from '../../utils';
import { Form } from '../../models';
import { I18n } from '@kineticdata/react';

export const RequestCard = connect(state => ({
  mobile: state.app.layoutSize === 'small',
}))(props => {
  const { submission, path, components = {} } = props;
  const CardTag = components.Link || Link;
  const form = Form(submission.form);
  const color = helpers.getRequestStatusColor(submission);
  const progress = !C.HIDE_PROGRESS_STATUSES.includes(
    helpers.getStatus(submission),
  )
    ? parseInt(submission.values[C.FIELD_PROGRESS], 10)
    : null;
  return (
    <RequestMetaWrapper submission={submission} navigate={props.navigate}>
      {meta => (
        <CardTag className="card" to={path}>
          <CardRow>
            <CardRow type="prepend" className="text-muted">
              <span className={`fa fa-fw fa-2x fa-${form.icon}`} />
            </CardRow>

            <CardCol>
              <CardRow className="text-muted">
                <span>
                  <strong>
                    <I18n>{form.name}</I18n>
                  </strong>
                  {' \u00b7 '}
                  {meta.showIdList().join(' \u00b7 ')}
                </span>
              </CardRow>
              <CardRow type="subtitle">
                <I18n>{submission.label}</I18n>
              </CardRow>
              {!!submission.values[C.FIELD_SUMMARY] && (
                <CardRow className="text-muted mb-1">
                  <I18n>{submission.values[C.FIELD_SUMMARY]}</I18n>
                </CardRow>
              )}
              <CardRow type="meta" className="text-muted">
                <dl className="flat">
                  {[
                    {
                      value: (
                        <span
                          className={`badge badge-${color} badge-stylized text-muted`}
                        >
                          <I18n>{helpers.getStatus(submission)}</I18n>
                        </span>
                      ),
                    },
                    {
                      label:
                        submission && submission.submittedAt
                          ? 'Submitted'
                          : 'Created',
                      value: meta.showDisplayDate(),
                    },
                    { value: meta.showSLT() },
                    { label: 'Closed', value: meta.showClosedDate() },
                    { label: 'Tracking', value: meta.showTracking() },
                    { label: 'Servers', value: meta.showServerNames() },
                    { value: meta.showIssues() },
                  ]
                    .filter(m => !!m.value)
                    .map(({ label, value }, i) => (
                      <div key={`meta-${i}`}>
                        {label && (
                          <dt>
                            <I18n>{label}</I18n>
                          </dt>
                        )}
                        {value && <dd>{value}</dd>}
                      </div>
                    ))}
                </dl>
              </CardRow>
            </CardCol>

            {!props.mobile && (
              <CardRow type="append">
                <UncontrolledDropdown className="actions-dropdown">
                  <DropdownToggle
                    color="outline-dark"
                    onClick={e => e.preventDefault()}
                  >
                    <span>
                      <I18n>Actions</I18n>
                    </span>
                    <span className="ml-1 fa fa-fw fa-angle-down" />
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <I18n>
                        {submission.coreState === C.CORE_STATE_DRAFT
                          ? 'Continue'
                          : 'Activity Details'}
                      </I18n>
                    </DropdownItem>
                    {[
                      {
                        label: 'Add Comment',
                        onClick: meta.handleAddComment({
                          preventDefault: true,
                        }),
                      },
                      {
                        label: 'Duplicate',
                        onClick: meta.handleClone({ preventDefault: true }),
                      },
                      {
                        label: meta.trackedCloneLabel,
                        onClick: meta.handleCloneWithTracking({
                          preventDefault: true,
                        }),
                      },
                      {
                        label: 'Cancel',
                        onClick: meta.handleCancel({
                          preventDefault: true,
                          success:
                            submission.coreState === C.CORE_STATE_DRAFT
                              ? props.reloadList
                              : undefined,
                        }),
                      },
                      {
                        label: 'Report Success/Failure',
                        onClick: meta.handleConfirmSuccess({
                          preventDefault: true,
                        }),
                      },
                      {
                        label: 'Escalate',
                        onClick: meta.handleEscalate({ preventDefault: true }),
                      },
                      {
                        label: 'PVG Override',
                        onClick: meta.handlePVGOverride({
                          preventDefault: true,
                        }),
                      },
                      {
                        label: 'Add Issue',
                        onClick: meta.handleAddIssue({ preventDefault: true }),
                      },
                    ]
                      .filter(a => !!a.onClick)
                      .map(({ label, onClick }, i) => (
                        <DropdownItem key={`action-${i}`} onClick={onClick}>
                          <I18n>{label}</I18n>
                        </DropdownItem>
                      ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardRow>
            )}
          </CardRow>
          {!!progress &&
            progress < 100 && (
              <div className="card__progress">
                <div
                  className="card__progress--bar"
                  style={{ width: `${progress}%` }}
                  title={`${progress}%`}
                  aria-label="Request Progress"
                >
                  <div className="card__progress--value">{progress}%</div>
                </div>
              </div>
            )}
        </CardTag>
      )}
    </RequestMetaWrapper>
  );
});
